<template>
  <div>
    <span class="btn-text" style="font-size:14px">{{userInfo.username ? ` ${userInfo.username}` : '未登录'}}</span>
    <el-dropdown size="small" class="d2-mr">
      <span class="avatar">
        <span v-if="userInfo.username">{{userInfo.username[0]}}</span>
        <span v-else class="el-icon-s-custom"></span>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          
          <router-link to="/center/index" style="color:inherit;text-decoration:none"><i class="iconfont iconoperate_pop_center"/>个人中心</router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          
          <router-link to="/matchlist/match/index" style="color:inherit;text-decoration:none"><i class="iconfont iconoperate_pop_match"/>赛事中心</router-link>
        </el-dropdown-item>
        <!-- <el-dropdown-item >
          <i class="iconfont iconwodewangpan_default"/>
          <router-link to="/scratchDisks" style="color:inherit;text-decoration:none">我的网盘</router-link>
        </el-dropdown-item> -->
        <el-dropdown-item>
          
          <router-link to="/shed/index" style="color:inherit;text-decoration:none"><i class="iconfont iconoperate_pop_setup"/>公棚设置</router-link>
        </el-dropdown-item>
        <el-dropdown-item @click.native="logOff">
          <i class="iconfont iconoperate_pop_signout"/>
          <span>退出登录</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters('d2admin/user', [
      'userInfo'
    ])
  },
  methods: {
    ...mapActions('d2admin/account', [
      'logout'
    ]),
    /**
     * @description 登出
     */
    logOff () {
      this.logout({
        confirm: true
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.avatar {
  display: inline-block;
  background: #dcebff;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  line-height: 40px;
  text-align: center;
  span {
    color: #437cfd;
    font-size: 20px;
  }
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
